module.exports = __webpack_public_path__ + "static/media/consulting_monochromatic.7854ab4c.svg";